import { useField } from "formik";

import { Checkbox, CheckboxProps } from "./Checkbox";
import { FormFeedback } from "../../../components/inputs/_assets/input-wrapper/FormFeedback";
import {
  InputWrapperProps,
  InputWrapper,
} from "../../../components/inputs/_assets/input-wrapper/InputWrapper";

interface Props extends CheckboxProps, Omit<InputWrapperProps, "children"> {
  name: string;
  info?: React.ReactNode;
  onSelect?: (value: boolean) => void;
}

/**
 * @deprecated use CheckboxFormikField
 */
export function CheckboxField({
  name,
  span = "auto",
  testID = "checkbox-field",
  ...props
}: Props) {
  const [field, meta, helpers] = useField(name);

  const handleChange = (value: boolean) => {
    props.onSelect?.(value);
    helpers.setValue(value);
  };

  return (
    <InputWrapper span={span}>
      <Checkbox
        isSelected={field.value}
        validationState={meta.error ? "invalid" : "valid"}
        {...field}
        {...props}
        onChange={handleChange}
        testID={testID}
      />
      <FormFeedback>{meta.touched && meta.error}</FormFeedback>
    </InputWrapper>
  );
}
